const configuredBase = process.env.REACT_APP_API_BASE_URL?.trim();

const apiBaseUrl = configuredBase && configuredBase.length > 0
  ? configuredBase
  : process.env.NODE_ENV === "development"
    ? "" // keep relative URLs so CRA proxy works locally
    : (typeof window !== "undefined" ? window.location.origin : "");

export function buildApiUrl(path = "") {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (!apiBaseUrl) {
    return normalized;
  }
  return `${apiBaseUrl}${normalized}`.replace(/([^:]\/)\/+/g, "$1");
}

export function apiFetch(path, init) {
  if (/^https?:\/\//i.test(path)) {
    return fetch(path, init);
  }
  return fetch(buildApiUrl(path), init);
}

export { apiBaseUrl as API_BASE_URL };
